import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { SymbolPriceAction } from './symbolPrice.action';
import { symbolPriceInitialState } from './symbolPrice.constant';
import { ISymbolPriceStore } from './symbolPrice.interface';

export const symbolPriceReducer = reducerWithInitialState(symbolPriceInitialState)
  .case(SymbolPriceAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(SymbolPriceAction.loadList.done, (state, { result }): ISymbolPriceStore => {
    const { items } = result;

    const data = { ...state.data };

    for (const item of items) {
      data[item.symbolId] = item;
    }

    return {
      ...state,
      data,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(SymbolPriceAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(SymbolPriceAction.destroy, () => ({
    ...symbolPriceInitialState,
  }));
